import React, { useState, useEffect } from 'react';
import {
  withRouter,
  Redirect,
  useHistory,
  useLocation,
} from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { resetPasswordAuth } from './redux/authApi';
// import LoginTextInput from '../common/form/LoginTextInput';
import BackToLogin from './part/BackToLogin';
import BodyAuth from './part/BodyAuth';
import { useWindowSize } from '../common/helpers/sizeHelper';
import ResetPasswordForm from './ResetPasswordForm';
const jwtDecode = require('jwt-decode');

function mapState(state) {
  return {
    auth: state.auth,
    loading: state.async.loading,
  };
}

const actions = {
  resetPasswordAuth,
};

function ResetPassword({ auth, loading, resetPasswordAuth }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');
  const tokenDecode = jwtDecode(token);
  const expiresIn = tokenDecode.exp * 1000;
  const username = queryParams.get('username');
  const email = queryParams.get('email');

  const [isExpired, setIsExpired] = useState(false);
  const [notif, setNotif] = useState(false);

  useEffect(() => {
    let checkExpired = setInterval(() => {
      if (Date.now() < expiresIn) {
        setIsExpired(false);
      } else {
        setIsExpired(true);
      }
    }, 100);

    return () => clearInterval(checkExpired);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExpired]);

  let windowSize = useWindowSize();

  const handleBackToLogin = () => {
    return history.push('/');
  };

  if (auth && auth.isAuth && auth.registerParents)
    return <Redirect to='/register-2' />;
  if (auth && auth.isAuth && !auth.registerParents)
    return <Redirect to='/dashboard' />;

  return (
    <BodyAuth
      title={''}
      width={
        windowSize[0] < 450 ? (windowSize[0] > 365 ? 365 : windowSize[0]) : 450
      }
    >
      {notif && (
        <div className='mx-4 mb-5'>
          <div className='has-text-centered mb-5 has-text-info'>
            <p className='is-size-5 has-text-semibold'>
              Reset Password Berhasil
            </p>
          </div>
          <p className='is-italic has-text-centered is-size-6 notification is-info is-light'>
            Password telah direset dengan password baru. Cek email untuk detail
            password baru.
          </p>
        </div>
      )}
      {!notif && (
        <div>
          <div className='has-text-centered mb-5 has-text-info'>
            <p className='is-size-6 has-text-weight-semibold'>Reset Password</p>
            <p className='has-text-info is-size-7 is-italic'>
              Isikan password baru untuk mereset password lama:
            </p>
            {isExpired && (
              <p className='has-text-info is-size-7 is-italic mt-4'>
                <span className='tag is-rounded is-danger'>
                  Link has expired
                </span>
              </p>
            )}
          </div>
          <ResetPasswordForm
            auth={auth}
            loading={loading}
            history={history}
            initialValues={{ token, username, email, newPass: '', confirmPass: '' }}
            dispatch={dispatch}
            setNotif={setNotif}
            isExpired={isExpired}
            resetPasswordAuth={resetPasswordAuth}
          />
        </div>
      )}
      <BackToLogin inBackToLogin={handleBackToLogin} />
    </BodyAuth>
  );
}

export default withRouter(connect(mapState, actions)(ResetPassword));
